// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avneue-no-vendor -> repli-sandbox-avneue-no-vendor -> the-lynx-3a34
// Generated: 2026-08-18T17:29:04.803Z
// Counts: 1 design, 14 content, 17 slot group, 0 collection binding, 3 section, 0 style

export const designOverrides = {
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#0095ff",
    "mappedField": null
  }
};

export const contentOverrides = {
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "asdfasdfasdf",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "110 Royyyyy",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitycardgrid.subheading": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>From the resort-style pool to the fully equipped fitness center, every space at The Lynx is designed to help you live well. Explore the amenities that make our San Antonio community feel like home.</p>",
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbSubtitle": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Elevated finishes in every home</p>",
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbText": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Step into a home where granite countertops, designer cabinetry, and stainless steel appliances make everyday moments feel a little more special. Sunlit rooms, spacious walk-in closets, and the ease of an in-home washer and dryer are thoughtful touches you'll appreciate from the moment you settle in. It's comfort and quality, considered down to the last detail.</p>",
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbTitle": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Designed Around You</p>",
    "mappedField": null
  },
  "featuredamenities.communityBlurbSubtitle": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Shared spaces made for connection</p>",
    "mappedField": null
  },
  "featuredamenities.communityBlurbText": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>From the rooftop terrace with sweeping San Antonio views to the clubhouse, sundeck, and resort-style pool, every gathering place at The Lynx is designed to bring neighbors together. Break a sweat in the fitness center, host friends in the gameroom, or let your pup run free at the bark park. Here, downtime feels like a getaway right outside your door.</p>",
    "mappedField": null
  },
  "featuredamenities.communityBlurbTitle": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to Live Well</p>",
    "mappedField": null
  },
  "gallery.apartment_blurb": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Choose from spacious one, two, and three-bedroom homes ranging from 400 to 1,125 square feet, each filled with natural light and room to relax and entertain. Designer interiors feature granite countertops with undermount sinks, stainless steel appliances, decorative tile backsplashes, and custom cabinetry. Select homes add nine-foot ceilings, sunrooms, fireplaces, built-in bookshelves, and in-home washer and dryer connections for everyday comfort.</p>",
    "mappedField": null
  },
  "gallery.community_blurb": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Life at The Lynx centers on our resort-style pool, sundeck, and roof terrace with sweeping San Antonio views. Stay active in the fully equipped fitness center, gather friends in the clubhouse, gameroom, and media center, or fire up the outdoor kitchen-style grill area. As a gated, pet-friendly community with a bark park and walking and biking trails, there's always somewhere to relax and connect.</p>",
    "mappedField": null
  },
  "hero.learn_more": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>The Lynx offers spacious one, two, and three-bedroom homes with granite countertops, stainless steel appliances, and generous walk-in closets. Residents enjoy a resort-style pool, a state-of-the-art fitness center, a bark park, and gathering spaces built for connection. Set in the heart of San Antonio, you're minutes from the city's dining, culture, and everyday conveniences. Schedule a tour to find the floor plan that fits your life.</p>",
    "mappedField": null
  },
  "hero.romance_blurb": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Come home to The Lynx, where sun-soaked San Antonio living meets thoughtfully designed comfort at every turn. Sink into a curved sofa after a workout, unwind poolside beneath swaying palms, or gather friends for a game beneath the Texas sky. This is a community made for the way you actually want to live.</p>",
    "mappedField": null
  },
  "petpolicy.intro": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At The Lynx, your four-legged family members are just as welcome as you are. Both dogs and cats can settle right in and enjoy our on-site Bark Park, pet play area, and pet washing station—so everyone in the household feels right at home.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitycardgrid.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-4168-7548-8d78-ab8820b2e33a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a sparkling blue swimming pool with lounge chairs and tables surrounding it."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Cool off and soak up the Texas sun at our sparkling resort-style pool, where lounge chairs and shaded seating make every afternoon feel like a getaway."
      }
    }
  },
  "amenitycardgrid.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-ef7a-71f0-92fb-3b98ddc9f692.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fitness center with treadmills, ellipticals, weight machines, and a tire."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Center"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Stay strong and energized in our state-of-the-art fitness center, stocked with cardio machines, weight stations, and functional training tools for every kind of workout."
      }
    }
  },
  "amenitycardgrid.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-d6bf-7092-8787-e1e78a9d1b91.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Dog park with agility equipment including tunnels, jumps, and benches."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pet Play Area"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Your furry friends will love our on-site bark park, complete with agility equipment and room to run, play, and socialize with the neighborhood pack."
      }
    }
  },
  "amenitycardgrid.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-444b-77d6-b63a-30d6ca24737a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment complex with outdoor basketball court and swimming pool."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Basketball Court"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Shoot hoops and stay active on our outdoor basketball court, the perfect spot for a friendly game just steps from your front door."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-571c-746e-aa81-74e26d24a02a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Master bedroom with a king-size bed, bedside tables with lamps, and blue curtains."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-26a2-748d-b045-97ef3fbab076.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of apartment buildings with brick facades and balconies."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-505c-73f4-8535-a5c0e559444a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings with parking lot and surrounding green spaces."
      }
    }
  },
  "ctasection.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-0460-77f9-a82c-68a275693c0c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Beach volleyball court with net, surrounded by green grass and trees. A building is visible in the background."
      }
    }
  },
  "gallery.hero_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-0176-73ff-ba4e-b9feb882d425.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees."
      }
    }
  },
  "gallery.hero_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-e89e-7188-ad13-5c789280ca94.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with a curved sofa, two accent chairs, a dark blue media console with a TV, and a wet bar."
      }
    }
  },
  "gallery.hero_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-571c-746e-aa81-74e26d24a02a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Master bedroom with a king-size bed, bedside tables with lamps, and blue curtains."
      }
    }
  },
  "petpolicy.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-cde0-747d-a746-354e3090d1de.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Dog park with agility equipment, benches, and apartment buildings in the background."
      }
    }
  },
  "petpolicy.lifestyle_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-d6bf-7092-8787-e1e78a9d1b91.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Dog park with agility equipment including tunnels, jumps, and benches."
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019d4f39-62c9-772b-938b-5f74fd1ca43b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "The Lynx apartment complex monument sign."
      }
    }
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfdde-e89e-7188-ad13-5c789280ca94.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with a curved sofa, two accent chairs, a dark blue media console with a TV, and a wet bar."
      }
    }
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-0176-73ff-ba4e-b9feb882d425.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees."
      }
    }
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162935/019cfddf-3b06-73da-8541-bb31e1f1577e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spin bikes in a modern gym with large mirrors and windows overlooking the pool."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 3
    }
  ]
};

export const styleOverrides = {};
